export default __webpack_public_path__ + "static/media/ladrillos-destacado.625bef53.png";